import { render } from "./DeclinedPayment.vue?vue&type=template&id=cd1b9eca"
import script from "./DeclinedPayment.vue?vue&type=script&lang=js"
export * from "./DeclinedPayment.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./DeclinedPayment.vue?vue&type=style&index=1&id=cd1b9eca&lang=css"

import exportComponent from "/var/www/html/cradle.staging.moko.africa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__